import { render, staticRenderFns } from "./DIconProcessingBarFlex.vue?vue&type=template&id=2022a7e5&scoped=true&"
import script from "./DIconProcessingBarFlex.vue?vue&type=script&lang=js&"
export * from "./DIconProcessingBarFlex.vue?vue&type=script&lang=js&"
import style0 from "./DIconProcessingBarFlex.vue?vue&type=style&index=0&id=2022a7e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2022a7e5",
  null
  
)

export default component.exports